<template>
    
    <tablecustom 
        @search="searchB" 
        :columns="columns" 
        :rows="filteredItems" 
        :objParams="objParams"
        @open="open"
        @openTerminal="openTerminal"
    />

    <viewTerminal 
        v-if="showTerminal"
        @close="showTerminal = false"
        :obj="objCard"
    />

    <viewTT 
        v-if="showOutletBox"
        @close="showOutletBox = false"
        :obj="objCard"
    />

</template>

<script>
import tablecustom from '@/components/globaltable/index';
import viewTerminal from '../terminals/viewTerminal/index'
import viewTT from './view'
import { mutateTariffingOutlets, mutateServerSyncOutlets } from '@/usabilityScripts/globalMutate.js'
import { Dashboard } from '@/API_Dash'

let apiServe = new Dashboard();

export default{
    props: ['obj', 'companyId'],
    components: {
        tablecustom,
        viewTerminal,
        viewTT
    },
    data(){
        return{
            form: '',
            objCard: '',
            showTerminal: false,
            showModal: false,
            showOutletBox: false,
            objParams: {
                search: ''
            },
            rows: '',
            columns: [
                {
                    name: "ID",
                    text: "tradepointId",
                    align: "left",
                    status: false,
                    copy: true,
                },
                {
                    name: this.$t("Name"),
                    text: "tradepointName",
                    align: "left",
                    status: true,
                    copy: true
                },
                {
                    name: this.$t("address"),
                    text: "tradepointData",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item) => item.contacts.address ? item.contacts.address : '-'
                },
                {
                    name: this.$t("Status"),
                    text: "tradepointStatus",
                    align: "left",
                    status: true,
                    copy: true,
                    mutate: (item, obj) => obj.deleted == true && obj.frozen.frozenStatus == false
                        ? this.mutateTariffing('removed').name 
                        : obj.frozen.frozenStatus == true && obj.deleted == true ? this.mutateTariffing('frozen').name
                        : item ? this.mutateTariffing(item).name : '-',
                    mutateClass: (item, obj) => obj.deleted == true && obj.frozen.frozenStatus == false
                        ? this.mutateTariffing('removed').color 
                        : obj.frozen.frozenStatus == true && obj.deleted == true ? this.mutateTariffing('frozen').color
                        : item ? this.mutateTariffing(item).color : '-',
                },
            ],
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(){
            this.rows = this.obj
        },
        open(e){
            this.objCard = e;
            this.showOutletBox = true;
        },
        openTerminal(e){
            apiServe.getTerminal(this.companyId, e.terminalId).then(result => {
                if(result.status == 'done'){
                    this.objCard = result.data;
                    this.showTerminal = true;
                } else if(result.status == 'error' && result.error[0] == 'empty company url'){
                    this.$toast.error(this.$t('emptyCompanyUrl'));
                } else {
                    this.$toast.error(this.$t('terminalNotFound'))
                }
            })
        },
        mutateTariffing(e){
          return mutateTariffingOutlets(e)
        },
        mutateServerSync(e){
            return mutateServerSyncOutlets(e)
        },
        searchB(e){
            this.objParams.search = e
        },
    },
    computed: {
        filteredItems: function() {
            return this.rows
                // по пошуку
                .filter(item => {
                    return this.objParams.search == '' || item.tradepointName.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1;
                })
        },
    }
}
</script>